// extracted by mini-css-extract-plugin
export default {"home":"Subject_SubScription_home__WsakS","hr":"Subject_SubScription_hr__BY44d","main":"Subject_SubScription_main__YE00-"};